import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher, getApiInstance } from "../utils/api";

export type OrderItem = {
  id: number;
  subscription?: number;
  service?: number;
  price: string;
  // السعر النهائي بعد الخصم إن وُجد من الباك اند
  total_after?: number | string;
  service_info?: {
    id: number;
    name: string;
    image?: string;
    prices: Array<{
      id: number;
      final_price: number;
      size: string;
    }>;
  };
  subscription_info?: {
    id: number;
    name: string;
    image?: string;
    prices: Array<{
      id: number;
      final_price: number;
      size: string;
    }>;
  };
};

export type Order = {
  id: number;
  created_at: string;
  updated_at: string;
  coupon?: string;
  items: OrderItem[];
  user_info?: {
    name: string;
    phone: string;
  };
  date?: string;
};

export type PaginatedResponse<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

export function useOrders(page: number = 1, date?: string, time?: string) {
  const dateParam = date ? `&date=${date}` : "";
  const timeParam = time ? `&time=${encodeURIComponent(time)}` : "";
  return useQuery<PaginatedResponse<Order>>({
    queryKey: ["orders", page, date, time],
    queryFn: () =>
      fetcher(`/store/orders/?page=${page}${dateParam}${timeParam}`),
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: false,
  });
}

export function useOrder(id: number) {
  return useQuery<Order>({
    queryKey: ["order", id],
    queryFn: () => fetcher(`/store/orders/${id}/`),
  });
}

export function useDeleteOrder() {
  const client = useQueryClient();
  const api = getApiInstance();

  return useMutation({
    mutationFn: (id: number) =>
      api.delete(`/store/orders/${id}/`).then((res) => res.data),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["orders"] });

      client.refetchQueries({ queryKey: ["orders"] });
    },
  });
}
